/**
 * Undo the pane's HARD WRAP, for display only — Clean View's reflow, out of its
 * component (M5, 2026-09-03).
 *
 * The machine sends the text exactly as the pane wraps it, because edge-side
 * continuity is matched on WRAPPED lines; a person reads paragraphs. So the display
 * joins what the pane broke — and only that. Structure (lists, headings, quotes,
 * tables, fences, indented code) is left alone, a fence tracks open/closed so nothing
 * inside one is ever joined, and CJK lines join WITHOUT the space a Latin join
 * inserts, because 中文 has no inter-word space for the wrap to have eaten.
 *
 * Moved verbatim from LiveBlock.tsx. It had zero direct tests there — the dedup around
 * it has eight, but the reflow itself was only ever exercised through a mounted
 * component, so none of the properties above had ever been asked as a question.
 */
const STRUCTURAL = /^(\s*([-*+•]|\d+[.)]|#{1,6}|>|\|)\s|\s{4,}\S|```)/u
export function unwrap(text: string): string {
  const out: string[] = []
  let fenced = false
  for (const line of text.split('\n')) {
    if (/^\s*```/.test(line)) fenced = !fenced
    const prev = out[out.length - 1]
    const joinable =
      !fenced &&
      prev !== undefined &&
      prev.trim() !== '' &&
      line.trim() !== '' &&
      !STRUCTURAL.test(line) &&
      !STRUCTURAL.test(prev)
    if (!joinable) {
      out.push(line)
      continue
    }
    out[out.length - 1] = /[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}]$/u.test(prev)
      ? prev + line.trim()
      : `${prev} ${line.trim()}`
  }
  return out.join('\n')
}

